import { render } from "./PaperRenderDetail.vue?vue&type=template&id=dd0728c4"
import script from "./PaperRenderDetail.vue?vue&type=script&lang=js"
export * from "./PaperRenderDetail.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3396806294/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__